<template>
  <div>
    <app-navbar v-on:toggleDrawer="toggleDrawer"/>
    <app-drawer v-model="drawer" />
    <v-row class="main mx-0 ml-md-n3">
      <v-col class="sidebar-col hidden-sm-and-down" md="3" sm="0">
        <sidebar class="hidden-sm-and-down" />
      </v-col>
      <v-col md="9" sm="12" class="default-slot">
        <div
          v-if="showContactWarning || showExpiredMembershipWarning || showNoMembershipWarning"
          class="pt-3"
        >
          <v-alert v-if="showContactWarning" class="mb-3" type="warning" icon="mdi-alert" outlined dense>
            <strong>Verify your contact information</strong>
            <div>Verify an email address or mobile phone number so you receive important notifications.</div>
            <v-btn class="mt-2" color="secondary" small @click="onUpdateProfile">UPDATE PROFILE</v-btn>
          </v-alert>
          <v-alert v-if="showExpiredMembershipWarning" class="mb-3" type="warning" icon="mdi-alert" outlined dense>
            <strong>Expired membership</strong>
            <div>Renew your membership and stay part of the ASCA family.</div>
            <v-btn class="mt-2" color="secondary" small @click="onRenewMembership">RENEW NOW</v-btn>
          </v-alert>
          <v-alert v-if="showNoMembershipWarning" class="mb-3" type="warning" icon="mdi-alert" outlined dense>
            <strong>No membership found.</strong>
            <div>Become part of the ASCA family by joining today.</div>
            <v-btn class="mt-2" color="secondary" small @click="onGainMembership">JOIN NOW</v-btn>
          </v-alert>
        </div>
        <slot />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Sidebar from './Sidebar.vue';
import AppDrawer from './AppDrawer.vue';
import AppNavbar from './AppNavbar.vue';
import { UserInfo } from "@/types/User";

import { ContactInfo } from "@/types/portal/Person";
import personService from "@/services/portal/personService";

export default Vue.extend({
  name: 'Home',
  data () {
    return {
      drawer: false,
      contactInfo: null as ContactInfo | null,
    }
  },
  props: {
    searchText: String,
  },
  components: {
    Sidebar,
    AppDrawer,
    AppNavbar,
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    isAdminOnly(): boolean {
      return !!this.userInfo && this.userInfo.isAdmin && this.userInfo.hasNeverBeenMember;
    },
    showContactWarning(): boolean {
      return !!this.contactInfo
        && (!(this.contactInfo.phoneNumber || this.contactInfo.email)
          || !(this.contactInfo.phoneNumberVerified || this.contactInfo.emailVerified));
    },
    showExpiredMembershipWarning(): boolean {
      return !!this.userInfo
        && !this.isAdminOnly
        && !this.userInfo.hasNeverBeenMember
        && !this.userInfo.isActiveMember;
    },
    showNoMembershipWarning(): boolean {
      return !!this.userInfo
        && !this.isAdminOnly
        && this.userInfo.hasNeverBeenMember;
    }
  },
  created: function () {
    this.loadUserContactInfo();
  },
  watch: {
    userInfo: function (newVal, oldVal) {
      if (newVal === oldVal) return;

      this.loadUserContactInfo();
    },
  },
  methods: {
    toggleDrawer: function () {
      this.drawer = !this.drawer
    },
    loadUserContactInfo: function () {
      if(!!this.userInfo){
        personService
          .getContactInformation()
          .then((res) => {
            if (res.found) {
              this.contactInfo = Object.assign({}, res.data);
          }}).catch(this.$handleError);
      }
    },
    onRenewMembership() {
      this.$navigate('/renew/member');
    },
    onUpdateProfile() {
      this.$navigate('/profile');
    },
    onGainMembership() {
      this.$navigate('/gain-membership');
    }
  }
});

</script>
